import { Button, Form, Input, Modal, Select, TreeSelect } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { FormInstance, FormProps } from 'antd/lib'
import React, { useEffect, useRef, useState } from 'react'
import useToast from '../../../hook/useToast'
import { getListDistrict, ISelectOption } from '../../../api/selectOptions/selectOptionsApi'
import { fommatSelectOption } from '../../../until'
import { addAgent } from '../../../api/agent/AgentApi'
import *as unitApi from "../../../api/unit/unitApi";
import * as SelectOptionApi from '../../../api/selectOptions/selectOptionsApi';
import { dataType } from '../../../services/data'
interface Props {
  show: boolean

  confirmModalAdd: (isSuccess: boolean, errorMessage?: string) => void
  modalClose?: () => void
}
const dataDefault = {
  provice: undefined as undefined | number,
  district: undefined as undefined | number,
}
const AddAgencyModal: React.FC<Props> = ({
  show,
  modalClose, confirmModalAdd,
}) => {
  const [form] = useForm()
  const inputRef = useRef<FormInstance>(null)
  const pushToast = useToast()

  const [valueUnit, setValueUnit] = useState<number>();

  const [sLDistrict, setSLDistrict] = useState<ISelectOption[]>([])

  const [dataListNationwide, setDataListNationwide] = useState<any>([])

  const [dataAddDefault, setDataAddDefault] = useState(dataDefault)
  const [listProvince, setListProvince] = useState<SelectOptionApi.provinceUnit[]>([])

  const getListIProvince = async (unitId?: number) => {
    const result = await SelectOptionApi.getProvinceUnit(unitId)
    if (result?.status) {
      if (unitId !== undefined) {
        setListProvince(result.data)
      } else {
        form.setFieldValue("province", undefined)
        setListProvince(result.data)
      }

    }
  }

  const gDistrict = async () => {
    const result = await getListDistrict(Number(dataAddDefault.provice));
    if (result?.status) {
      setSLDistrict(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
  }

  const gListNationwide = async () => {
    const result = await SelectOptionApi.getAgentListNationwide();

    if (result?.status) {
      setDataListNationwide(unitApi.convertNationwideValueToTree_V2(result.data))
    } else {
    }
  }
  const onChange = (value: number) => {
    setValueUnit(value);
    getListIProvince(value)
  }
  //danh sách đơn vị

  const submitForm = () => {
    if (inputRef?.current) {
      inputRef?.current.submit();
    }
  };
  const onFormFinish: FormProps["onFinish"] = async (values) => {

    const result = await addAgent(values.code, values.name, values.unit, values.province, values.type, values.phoneNumber, values.email, values.address, values.linkWebsite)
    if (result?.status) {
      confirmModalAdd?.(true)
    } else {
      confirmModalAdd?.(false, result?.message)
    }
  }

  useEffect(() => {
    if (dataAddDefault.provice) {
      gDistrict()
    } else {
    }
  }, [dataAddDefault.provice])

  useEffect(() => {
    if (show) {
      gListNationwide()
    } else {
      form.resetFields()
    }
  }, [show])
  return (
    <Modal
      open={show}
      title='Tạo mới Showroom'
      className='rs-modal w-400 footer-content-end add-relative-modal'
      centered
      footer={
        <>
          <Button
            className='rs-button rs-button--sm'
          >Hủy</Button>
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            onClick={submitForm}
          >Xác nhận</Button>
        </>
      }
      onCancel={modalClose}
    >
      <Form
        form={form}
        ref={inputRef}
        className='rs-form add-relative-form'
        onFinish={onFormFinish}
        requiredMark={false}
        layout='vertical'
      >
        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            <span className="text-F5222D">*</span>
            Mã showroom:
          </p>
          <Form.Item
            name='code'
            rules={[
              { required: true, message: "Vui lòng nhập Mã showroom" }
            ]}
          >
            <Input
              placeholder='Mã showroom'
              className='rs-input rs-input--32'
            />
          </Form.Item>
        </div>
        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            <span className="text-F5222D">*</span>
            Tên showroom:
          </p>
          <Form.Item
            name='name'
            rules={[
              { required: true, message: "Vui lòng nhập Tên showroom" }
            ]}
          >
            <Input
              placeholder='Tên showroom'
              className='rs-input rs-input--32'
            />
          </Form.Item>
        </div>

        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            <span className="text-F5222D">*</span>
            Chọn đơn vị:
          </p>
          <Form.Item
            name="unit"
            rules={[{ required: true, message: 'Vui lòng chọn đơn vị!' }]}
            className="m-none-form-item text-explan"
          >
            <TreeSelect
              showSearch
              value={valueUnit}
              placeholder="Chọn đơn vị"
              allowClear
              treeDefaultExpandAll={false}
              onChange={onChange}
              treeData={dataListNationwide}
              className="custom-tree-select "
              filterTreeNode={(input: string, option: any) =>
                typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }

            />
          </Form.Item>
        </div>

        {/* <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            <span className="text-F5222D">*</span>
            Chọn tỉnh thành :
          </p>
          <Form.Item
            name='province'
            rules={[
              { required: true, message: "Vui lòng chọn tỉnh thành" }
            ]}
          >
            <Select
              placeholder='Chọn tỉnh thành'
              className='rs-select'

              options={fommatSelectOption(listProvince)}
            />
          </Form.Item>
        </div> */}
        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            <span className="text-F5222D">*</span>
            Loại hình :
          </p>
          <Form.Item
            name='type'
            rules={[
              { required: true, message: "Vui lòng chọn loại hình" }
            ]}
          >
            <Select
              placeholder='Chọn loại hình'
              className='rs-select'

              options={dataType}

            />
          </Form.Item>
        </div>

        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 ">
            Số điện thoại :
          </p>
          <Form.Item
            name='phoneNumber'
            rules={[
              // { required: true, message: "Vui lòng nhập Số điện thoại" },
              {
                pattern: /^0\d{9}$/,
                message: "Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)",
              },
            ]}
          >
            <Input
              placeholder='Số điện thoại'
              className='rs-input rs-input--32'
              type='tel'
            />
          </Form.Item>
        </div>

        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 ">
            Địa chỉ :
          </p>
          <Form.Item
            name='address'
            rules={[
              // { required: true, message: "Vui lòng nhập Địa chỉ" }
            ]}
          >
            <Input
              placeholder='Địa chỉ'
              className='rs-input rs-input--32'
            />
          </Form.Item>
        </div>
        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 ">
            Link website :
          </p>
          <Form.Item
            name='linkWebsite'
            rules={[
              // { required: true, message: "Vui lòng nhập Link website" }
            ]}
          >
            <Input
              placeholder='Link website'
              className='rs-input rs-input--32'
            />
          </Form.Item>
        </div>

        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 ">
            Email :
          </p>
          <Form.Item
            name='email'
            rules={[
              // { required: true, message: "Vui lòng nhập Email" },
              {
                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Email không hợp lệ"
              }
            ]}
          >
            <Input
              placeholder='Email'
              className='rs-input rs-input--32'
            />
          </Form.Item>
        </div>






        {/* <Form.Item
          name='district'
          rules={[
            // { required: true, message: "Vui lòng chọn Quận huyện" }
          ]}
        >
          <Select
            placeholder='Quận huyện'
            className='rs-select'
             
            options={sLDistrict}
            value={dataAddDefault.district}
            onChange={(e: number) => setDataAddDefault({ ...dataAddDefault, district: e })}
          />
        </Form.Item> */}

        {/* <Form.Item
          name='ward'
          rules={[
            { required: true, message: "Vui lòng chọn Phường" }
          ]}
        >
          <Select
            placeholder='Phường'
            className='rs-select'
             
            options={[{ value: '1', label: 'Phường' }]}
          />
        </Form.Item> */}


      </Form>
    </Modal>
  )
}

export default AddAgencyModal
